import { any, array, boolean, lazy, number, object, optional, picklist, pipe, record, regex, string, } from 'valibot';
/** This file contains the Valibot schemas to ensure data passed to the client is correctly formatted */
/** The schema for a child in the config */
export const DocConfigSchema = object({
    isCollection: optional(boolean()),
    type: optional(picklist(['last_write_wins', 'operational_transformation'])),
    versioned: optional(boolean()),
    access: optional(picklist(['admin_only', 'global_read', 'user_read', 'user_write', 'role'])),
    children: optional(lazy(() => record(string(), DocConfigSchema))),
});
/** The schema for the config passed to the client */
export const ConfigSchema = object({
    name: string(),
    domain: pipe(string(), regex(/^([a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,10}|localhost:\d{2,6})$/i, 'Invalid domain')),
    children: record(string(), DocConfigSchema),
});
export const validDate = (value) => {
    return 1483228800000 < value && value < Date.now() + 1000 * 60 * 60;
};
/** The schema for a JSON Patch operation */
export const JSONPatchOpSchema = object({
    op: picklist(['add', 'remove', 'replace', 'move', 'copy', 'test', '@inc', '@bit', '@changeText']),
    path: string(),
    value: optional(any()),
    from: optional(string()),
    soft: optional(boolean()),
});
export const ChangeSchema = object({
    patch: array(JSONPatchOpSchema),
    rev: string(),
    id: optional(any()),
    created: optional(number()),
    committed: optional(number()),
});
/** The schema for a JSON Patch */
export const ChangeMessageSchema = object({
    path: string(),
    changes: optional(array(ChangeSchema)),
    doc: optional(any()),
    rev: optional(string()),
    deleted: optional(boolean()),
});
